import uniqueId from 'lodash/uniqueId';

const unique = (value: string) => `${uniqueId()}_${value}`;

export {unique};
